module.exports = __webpack_public_path__ + "img/1516838160.42c7c515.jpg";